import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/stockhouse";
import Services from "../../Services/Services";

export default class Stockhouse extends Page {
  title = "home";

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle("Casa di Patsi Stock - STOCKHOUSE");

    Services.get("content").then(([content]) => {
      content.getCategories().then((content) => {
        this.setData({
          "default.categories": content.getData("categories", []),
          "default.page": 2,
          "default.wishlist": this.getWishlist(),
        });
      });
    });

    this.addScripts({
      "jquery.min": "assets/js/jquery.min",
      "bootstrap.bundle.min": "assets/js/bootstrap.bundle.min",
      "jquery.hoverIntent.min": "assets/js/jquery.hoverIntent.min",
      "jquery.waypoints.min": "assets/js/jquery.waypoints.min",
      "superfish.min": "assets/js/superfish.min",
      "owl.carousel.min": "assets/js/owl.carousel.min",
      "jquery.plugin.min": "assets/js/jquery.plugin.min",
      "jquery.magnific-popup.min": "assets/js/jquery.magnific-popup.min",
      "jquery.countdown.min": "assets/js/jquery.countdown.min",
      main: "assets/js/main",
      "demo-2": "assets/js/demos/demo-2",
    });

    const uluru = { lat: 38.0675964, lng: 23.7551095 };

    this.map = new window.google.maps.Map(
      document.getElementById("custom_map"),
      {
        zoom: 16,
        center: uluru,
      }
    );

    var marker = new window.google.maps.Marker({
      position: uluru,
      map: this.map,
    });
    window.google.maps.event.addListener(marker, "click", function () {
      this.map.panTo(this.getPosition());
      this.map.setZoom(19);
    });

    window.scrollTo({
      top: 0,
      left: 0,
    });

    this.setSeoData();
  }

  async setSeoData() {
    const account = this.getHelpers("env").getDefaultAccount();
    const repository = this.getHelpers("env").getDefaultRepository();

    const translations = await this.getHelpers("translate").scope({
      account,
      repository,
      entity: "item",
      entity_slug: "seo",
      scope: "default",
    });

    const description = translations.find(
      (translation) => translation.slug === "default-description"
    ) || { translation: "" };

    const keywords = translations.find(
      (translation) => translation.slug === "default-keywords"
    ) || { translation: "" };

    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", description.translation);

    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", keywords.translation);
  }

  getWishlist() {
    const wishlist = this.getHelpers("state").get("wishlist");
    if (wishlist) {
      var array = wishlist.split(",");
      return array;
    } else {
      return [];
    }
  }

  checkSearch(e) {
    e.preventDefault();
    const devHelper = this.getHelpers("env").getPublicUrl();
    if (document.getElementById("search").value.length > 1) {
      window.location.href =
        devHelper + "/results/" + document.getElementById("search").value;
    }
  }
  checkSearchMobile(e) {
    e.preventDefault();
    const devHelper = this.getHelpers("env").getPublicUrl();
    if (document.getElementById("search_mobile").value.length > 1) {
      window.location.href =
        devHelper +
        "/results/" +
        document.getElementById("search_mobile").value;
    }
  }
}
